function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case './assets/accept-alt.js': return import('./accept-alt-937229be.js');
    case './assets/accept.js': return import('./accept-53dbaac1.js');
    case './assets/activity-log.js': return import('./activity-log-62ba55d0.js');
    case './assets/alert-alt.js': return import('./alert-alt-caced21c.js');
    case './assets/alert.js': return import('./alert-1af6f7e4.js');
    case './assets/arrow-down-alt.js': return import('./arrow-down-alt-f3462100.js');
    case './assets/arrow-down.js': return import('./arrow-down-ae25fc91.js');
    case './assets/arrow-left-alt.js': return import('./arrow-left-alt-c486f745.js');
    case './assets/arrow-left.js': return import('./arrow-left-5d7f62ac.js');
    case './assets/arrow-right-alt.js': return import('./arrow-right-alt-8ac2ffce.js');
    case './assets/arrow-right.js': return import('./arrow-right-4afb937f.js');
    case './assets/arrow-small-down-alt.js': return import('./arrow-small-down-alt-114d4a06.js');
    case './assets/arrow-small-down.js': return import('./arrow-small-down-41989848.js');
    case './assets/arrow-small-left-alt.js': return import('./arrow-small-left-alt-2ea20a03.js');
    case './assets/arrow-small-left.js': return import('./arrow-small-left-efe9b4cc.js');
    case './assets/arrow-small-right-alt.js': return import('./arrow-small-right-alt-cf6dbc33.js');
    case './assets/arrow-small-right.js': return import('./arrow-small-right-7777c36f.js');
    case './assets/arrow-small-up-alt.js': return import('./arrow-small-up-alt-4496c715.js');
    case './assets/arrow-small-up.js': return import('./arrow-small-up-90fcd2fb.js');
    case './assets/arrow-up-alt.js': return import('./arrow-up-alt-3c8dfc8f.js');
    case './assets/arrow-up.js': return import('./arrow-up-7941a826.js');
    case './assets/audit-trail-alt.js': return import('./audit-trail-alt-369ada29.js');
    case './assets/audit-trail.js': return import('./audit-trail-1ed8e58a.js');
    case './assets/auto.js': return import('./auto-6df40b0b.js');
    case './assets/bell-alt.js': return import('./bell-alt-a05136bb.js');
    case './assets/bell.js': return import('./bell-9bfcf82d.js');
    case './assets/bl-auto-alt.js': return import('./bl-auto-alt-3da76194.js');
    case './assets/bl-auto.js': return import('./bl-auto-a414b222.js');
    case './assets/bl-home-alt.js': return import('./bl-home-alt-68231ab3.js');
    case './assets/bl-home.js': return import('./bl-home-509e5dd9.js');
    case './assets/bl-liability-private-alt.js': return import('./bl-liability-private-alt-d7989215.js');
    case './assets/bl-liability-private.js': return import('./bl-liability-private-9d13cef2.js');
    case './assets/camera-alt.js': return import('./camera-alt-53db51ca.js');
    case './assets/camera.js': return import('./camera-f7514e68.js');
    case './assets/cancel-alt.js': return import('./cancel-alt-e329f029.js');
    case './assets/cancel.js': return import('./cancel-8abc6ec7.js');
    case './assets/check-alt.js': return import('./check-alt-38753f8e.js');
    case './assets/check.js': return import('./check-3bca5034.js');
    case './assets/chevron-down-alt-lg.js': return import('./chevron-down-alt-lg-62fe4f3e.js');
    case './assets/chevron-down-alt-md.js': return import('./chevron-down-alt-md-d4211cca.js');
    case './assets/chevron-down-alt-sm.js': return import('./chevron-down-alt-sm-c2fc3ef4.js');
    case './assets/chevron-down.js': return import('./chevron-down-85ca6df3.js');
    case './assets/chevron-left-alt-lg.js': return import('./chevron-left-alt-lg-6242b8d0.js');
    case './assets/chevron-left-alt-md.js': return import('./chevron-left-alt-md-dcb7c506.js');
    case './assets/chevron-left.js': return import('./chevron-left-afc1e106.js');
    case './assets/chevron-right-alt-lg.js': return import('./chevron-right-alt-lg-e29d4506.js');
    case './assets/chevron-right-alt-md.js': return import('./chevron-right-alt-md-a35af2ac.js');
    case './assets/chevron-right.js': return import('./chevron-right-245867b2.js');
    case './assets/chevron-up-alt-lg.js': return import('./chevron-up-alt-lg-bbf36c6c.js');
    case './assets/chevron-up-alt-md.js': return import('./chevron-up-alt-md-2b4feca4.js');
    case './assets/chevron-up-alt-sm.js': return import('./chevron-up-alt-sm-71110746.js');
    case './assets/chevron-up.js': return import('./chevron-up-eabc9a7d.js');
    case './assets/comment-alt.js': return import('./comment-alt-5b048df4.js');
    case './assets/comment.js': return import('./comment-bf438b6d.js');
    case './assets/copy-alt.js': return import('./copy-alt-b6c17184.js');
    case './assets/copy.js': return import('./copy-5ce01a4b.js');
    case './assets/cross-alt.js': return import('./cross-alt-ec133857.js');
    case './assets/cross.js': return import('./cross-28b12b0e.js');
    case './assets/danger-alt.js': return import('./danger-alt-27338ee3.js');
    case './assets/danger.js': return import('./danger-51071bdd.js');
    case './assets/delete-alt.js': return import('./delete-alt-73abe693.js');
    case './assets/delete.js': return import('./delete-3a17896c.js');
    case './assets/diagnostics-alt.js': return import('./diagnostics-alt-6bcbc77f.js');
    case './assets/diagnostics.js': return import('./diagnostics-9a666483.js');
    case './assets/download-alt.js': return import('./download-alt-02c7e520.js');
    case './assets/download.js': return import('./download-a7fa2ea6.js');
    case './assets/edit-alt.js': return import('./edit-alt-730c5337.js');
    case './assets/edit.js': return import('./edit-c6b7ddd0.js');
    case './assets/filter-alt.js': return import('./filter-alt-fec2111d.js');
    case './assets/filter.js': return import('./filter-9e82bf17.js');
    case './assets/globe-alt.js': return import('./globe-alt-35546ce2.js');
    case './assets/globe.js': return import('./globe-0d40de5e.js');
    case './assets/home.js': return import('./home-9ec03f03.js');
    case './assets/important-alt.js': return import('./important-alt-79572030.js');
    case './assets/important.js': return import('./important-2e91e241.js');
    case './assets/indicator.js': return import('./indicator-96f874a6.js');
    case './assets/indicators-alt.js': return import('./indicators-alt-43a2b626.js');
    case './assets/indicators.js': return import('./indicators-83745667.js');
    case './assets/information-alt.js': return import('./information-alt-69bc2560.js');
    case './assets/information.js': return import('./information-37908c0c.js');
    case './assets/liability-private.js': return import('./liability-private-71bc3850.js');
    case './assets/log-alt.js': return import('./log-alt-08ec5f87.js');
    case './assets/log.js': return import('./log-cbd63c30.js');
    case './assets/map-alt.js': return import('./map-alt-c53924d2.js');
    case './assets/map.js': return import('./map-ce4124cb.js');
    case './assets/menu.js': return import('./menu-09809382.js');
    case './assets/network-view-alt.js': return import('./network-view-alt-2d570b0a.js');
    case './assets/network-view.js': return import('./network-view-e55feac1.js');
    case './assets/person-alt.js': return import('./person-alt-f0f6a547.js');
    case './assets/person.js': return import('./person-1fd1ad00.js');
    case './assets/persons-alt.js': return import('./persons-alt-3e6745f3.js');
    case './assets/persons.js': return import('./persons-acdb21cf.js');
    case './assets/refresh-alt.js': return import('./refresh-alt-c26bfccb.js');
    case './assets/refresh.js': return import('./refresh-4c0a1148.js');
    case './assets/screening-diagnostics-alt.js': return import('./screening-diagnostics-alt-894c825d.js');
    case './assets/screening-diagnostics.js': return import('./screening-diagnostics-6657d037.js');
    case './assets/succes.js': return import('./succes-c132b5dc.js');
    case './assets/success-alt.js': return import('./success-alt-c3674954.js');
    case './assets/testing.js': return import('./testing-e4027b6f.js');
    case './assets/trash.js': return import('./trash-0cff3cde.js');
    case './assets/upload-alt.js': return import('./upload-alt-a6180b10.js');
    case './assets/upload.js': return import('./upload-a9f05a44.js');
    case './assets/user-alt.js': return import('./user-alt-3ab6a92a.js');
    case './assets/user.js': return import('./user-1f3874b0.js');
    case './assets/warning-alt.js': return import('./warning-alt-bad94003.js');
    case './assets/warning.js': return import('./warning-fafb07c1.js');
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

class FrissIcon extends HTMLElement {
    constructor() {
        super();
        this.render = this.render.bind(this);
        this.connectedCallback = this.connectedCallback.bind(this);
        this.applyStyles = this.applyStyles.bind(this);
        this.getSizePx = this.getSizePx.bind(this);
        this.isRightFloat = this.isRightFloat.bind(this);
        this.getIcon = this.getIcon.bind(this);
        this.attributeChangedCallback = this.attributeChangedCallback.bind(this);
    }
    async connectedCallback() {
        await this.render();
    }
    async render() {
        this.innerHTML = await this.getIcon();
        this.applyStyles();
    }
    applyStyles() {
        this.style.width = this.getSizePx();
        this.style.height = this.getSizePx();
        this.style.display = 'inline-flex';
        this.classList.add(this.isRightFloat() ? 'friss-icon--right' : 'friss-icon--left');
    }
    getSizePx() {
        // Determine the width of the svg viewbox.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const viewBoxSize = this.children[0]
            .getAttribute('viewBox')
            .split(/\s+|,/);
        const viewBoxWidth = viewBoxSize[2];
        return viewBoxWidth + 'px';
    }
    isRightFloat() {
        return this.getAttribute('right') === '';
    }
    async getIcon() {
        const iconName = this.getAttribute('name');
        return (await __variableDynamicImportRuntime0__(`./assets/${iconName}.js`))?.default;
    }
    static get observedAttributes() {
        return ['name', 'right'];
    }
    async attributeChangedCallback() {
        await this.render();
    }
}

var catalogue = [
    'accept-alt',
    'accept',
    'activity-log',
    'alert-alt',
    'alert',
    'arrow-down-alt',
    'arrow-down',
    'arrow-left-alt',
    'arrow-left',
    'arrow-right-alt',
    'arrow-right',
    'arrow-small-down-alt',
    'arrow-small-down',
    'arrow-small-left-alt',
    'arrow-small-left',
    'arrow-small-right-alt',
    'arrow-small-right',
    'arrow-small-up-alt',
    'arrow-small-up',
    'arrow-up-alt',
    'arrow-up',
    'audit-trail-alt',
    'audit-trail',
    'auto',
    'bell-alt',
    'bell',
    'bl-auto-alt',
    'bl-auto',
    'bl-home-alt',
    'bl-home',
    'bl-liability-private-alt',
    'bl-liability-private',
    'camera-alt',
    'camera',
    'cancel-alt',
    'cancel',
    'check-alt',
    'check',
    'chevron-down-alt-lg',
    'chevron-down-alt-md',
    'chevron-down-alt-sm',
    'chevron-down',
    'chevron-left-alt-lg',
    'chevron-left-alt-md',
    'chevron-left',
    'chevron-right-alt-lg',
    'chevron-right-alt-md',
    'chevron-right',
    'chevron-up-alt-lg',
    'chevron-up-alt-md',
    'chevron-up-alt-sm',
    'chevron-up',
    'comment-alt',
    'comment',
    'copy-alt',
    'copy',
    'cross-alt',
    'cross',
    'danger-alt',
    'danger',
    'delete-alt',
    'delete',
    'diagnostics-alt',
    'diagnostics',
    'download-alt',
    'download',
    'edit-alt',
    'edit',
    'filter-alt',
    'filter',
    'globe-alt',
    'globe',
    'home',
    'important-alt',
    'important',
    'indicator',
    'indicators-alt',
    'indicators',
    'information-alt',
    'information',
    'liability-private',
    'log-alt',
    'log',
    'map-alt',
    'map',
    'menu',
    'network-view-alt',
    'network-view',
    'person-alt',
    'person',
    'persons-alt',
    'persons',
    'refresh-alt',
    'refresh',
    'screening-diagnostics-alt',
    'screening-diagnostics',
    'succes',
    'success-alt',
    'testing',
    'trash',
    'upload-alt',
    'upload',
    'user-alt',
    'user',
    'warning-alt',
    'warning'
];

const installFrissIcons = function () {
    if (customElements.get('friss-icon') === undefined) {
        customElements.define('friss-icon', FrissIcon);
    }
    else {
        // eslint-disable-next-line no-console
        console.warn('<friss-icon> custom element is already defined. You only need to install FRISS Icons once.');
    }
};

export { catalogue, installFrissIcons };
